
    import { Vue, Options } from "vue-class-component";
    import { Emit, Model, Prop, Watch } from "vue-property-decorator";
    import { ElMessage } from "element-plus";
    import MiezzButton from "@/models/MiezzButton";
    import MiezzForm from "@/models/MiezzForm";
    import MiezzModal from "@/models/MiezzModal";
    import DeliveryRequirementAppService from "@/apis.machine/DeliveryRequirementAppService";
    import DtoDetailDeliveryRequirement, {
        DtoDetailDeliveryRequirementMiezzDetailItems,
    } from "@/models.machine/DtoDetailDeliveryRequirement";
    import DeliveryRequirementForm from "./DeliveryRequirementForm.vue";

    @Options({
        components: {
            DeliveryRequirementForm,
        },
    })
    export default class DeliveryRequirementDetail extends Vue {
        @Model() modelValue!: MiezzModal;
        @Prop() id?: string;

        detail = new MiezzForm<DtoDetailDeliveryRequirement, string>();
        modalForm = new MiezzModal();

        /**创建时 */
        created(): void {
            //详细-数据-初始化
            this.detail.Data = new DtoDetailDeliveryRequirement();
            //详细-元素配置
            this.detail.Items = DtoDetailDeliveryRequirementMiezzDetailItems;
            this.modelValue.HandleClick = this.handleClick;
            this.modelValue.Buttons = [
                {
                    Code: "edit",
                    Title: "编辑",
                    Icon: "edit",
                    Type: "default",
                    Size: "small",
                    PowerCode: "System_ParamList_DeliveryRequirements_AddEdit",
                },
                {
                    Code: "delete",
                    Title: "删除",
                    Icon: "delete",
                    Type: "default",
                    Message: "是否确认删除",
                    Size: "small",
                    PowerCode: "System_ParamList_DeliveryRequirements_Delete"
                },
            ];
            this.handleGet();
        }

        /**查询详细 */
        handleGet(): void {
            if (this.id) {
                DeliveryRequirementAppService.GetById(this.id).then((r) => {
                    if (r.data.Data) this.detail.Data = r.data.Data;
                });
            }
        }

        /**按钮点击 */
        handleClick(btn: MiezzButton, complete: () => void): void {
            switch (btn.Code) {
                case "edit":
                    this.modalForm.Show = true;
                    this.modalForm.Title = `编辑交期要求-${this.detail.Data.Name}`;
                    complete();
                    break;
                case "delete":
                    DeliveryRequirementAppService.Delete([this.id as string])
                        .then(() => {
                            this.handleDelete();
                            complete();
                        })
                        .catch(complete);
                    break;
                default:
                    break;
            }
        }

        /**提交表单 */
        @Emit()
        handleSubmit(): void {
            this.modalForm.Show = false;
            this.handleGet();
        }

        /**删除 */
        @Emit()
        handleDelete(): void {
            //
        }
    }
